// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    LoginDTOAPIModel,
    LoginDTOAPIModelFromJSON,
    LoginDTOAPIModelToJSON,
    LoginResponseDTOAPIModel,
    LoginResponseDTOAPIModelFromJSON,
    LoginResponseDTOAPIModelToJSON,
} from '../models';

export interface AuthControllerLoginRequest {
    loginDTOAPIModel: LoginDTOAPIModel;
}

/**
 * AuthApi - interface
 * 
 * @export
 * @interface AuthApiInterface
 */
export interface AuthApiInterface {
    /**
     * 
     * @param {LoginDTOAPIModel} loginDTOAPIModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerLoginRaw(requestParameters: AuthControllerLoginRequest): Promise<runtime.ApiResponse<LoginResponseDTOAPIModel>>;

    /**
     */
    authControllerLogin(loginDTOAPIModel: LoginDTOAPIModel): Promise<LoginResponseDTOAPIModel>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    authControllerLogoutRaw(): Promise<runtime.ApiResponse<void>>;

    /**
     */
    authControllerLogout(): Promise<void>;

}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI implements AuthApiInterface {

    /**
     */
    async authControllerLoginRaw(requestParameters: AuthControllerLoginRequest): Promise<runtime.ApiResponse<LoginResponseDTOAPIModel>> {
        if (requestParameters.loginDTOAPIModel === null || requestParameters.loginDTOAPIModel === undefined) {
            throw new runtime.RequiredError('loginDTOAPIModel','Required parameter requestParameters.loginDTOAPIModel was null or undefined when calling authControllerLogin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/auth/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginDTOAPIModelToJSON(requestParameters.loginDTOAPIModel),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseDTOAPIModelFromJSON(jsonValue));
    }

    /**
     */
    async authControllerLogin(loginDTOAPIModel: LoginDTOAPIModel): Promise<LoginResponseDTOAPIModel> {
        const response = await this.authControllerLoginRaw({ loginDTOAPIModel: loginDTOAPIModel });
        return await response.value();
    }

    /**
     */
    async authControllerLogoutRaw(): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async authControllerLogout(): Promise<void> {
        await this.authControllerLogoutRaw();
    }

}
